import { IRIS_APPLICATION_ALIAS } from '@iris/common/models/IrisApplication';

export function resolveAppAlias(appAlias: string | null, fallback = IRIS_APPLICATION_ALIAS): string {
  // If app alias is defined returns immediatelly
  if (appAlias?.trim()) {
    return appAlias;
  }

  const path = window.location.pathname || '';

  const segments = path.split('/').filter(Boolean);

  const isOldFEBasePath = segments[0] === 'ui' && segments[1] === 'ui2';

  // If the url is of type ui/ui2/* it uses the fallback appAlias
  if (isOldFEBasePath || segments.length === 0) {
    return fallback;
  }

  // If no appAlias is provided and no ui/ui2 is set and the url as at least one segment
  // it uses the first segment as appAlias.
  // Not valid appAlias should be managed with other logic
  return segments[0];

}
